export default __webpack_public_path__ + "static/media/werking.a7e03c9a.JPG";